import React from 'react';
import {EventCategory} from 'src/models';
import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {withObservables} from '@nozbe/watermelondb/react';
import {Q} from '@nozbe/watermelondb';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';
import {of} from '@nozbe/watermelondb/utils/rx';

interface Props {
  name: string;
  items: any[];
  label?: string;
}

const EventCategorySelect = ({
  name,
  items,
  label = 'Select General Event',
}: Props) => {
  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + 'eventId'}
      label={label}
      required={false}
      multiple={false}
      selectAll={false}
      searchable={false}
      items={items}
    />
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables([], ({database, authentication}: any) => ({
    eventCategories: database
      .get(EventCategory.table)
      .query(
        Q.where('deleted_at', null),
        Q.where('_partition', authentication.selectedGroup),
      ),
  })),
  withObservables(['eventCategories'], ({eventCategories}: any) => {
    return {
      items: of(
        eventCategories.map((event: EventCategory) => {
          return {
            label: `${event.name}`,
            value: event.id,
          };
        }),
      ),
    };
  }),
)(EventCategorySelect);
